import { apiRequest } from '../api/client';

async function uploadMedia(file, fetchImpl = fetch) {
  const response = await fetchImpl('/api/v1/community/media', {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': file.type }, body: file,
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) throw new Error(payload && payload.message ? payload.message : 'No se pudo subir la foto.');
  return payload;
}

export function resizeCommunityImage(file) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const url = URL.createObjectURL(file);
    image.onload = () => {
      const scale = Math.min(1, 1600 / Math.max(image.width, image.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.width * scale));
      canvas.height = Math.max(1, Math.round(image.height * scale));
      canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('No se pudo procesar la foto.')), 'image/jpeg', 0.86);
    };
    image.onerror = () => { URL.revokeObjectURL(url); reject(new Error('No se pudo leer la foto.')); };
    image.src = url;
  });
}

export const communityMedia = { resize: resizeCommunityImage, upload: uploadMedia };

export const communityApi = {
  async publish({ body, files = [] }) {
    const mediaIds = [];
    for (const original of files.slice(0, 4)) {
      const image = await communityMedia.resize(original);
      const uploaded = await communityMedia.upload(image);
      mediaIds.push(uploaded.mediaId);
    }
    return apiRequest('/community/posts', { method: 'POST', body: { body, mediaIds } });
  },
  feed: ({ scope = 'all', cursor } = {}) => apiRequest(`/community/feed?scope=${encodeURIComponent(scope)}${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`),
  getPost: postId => apiRequest(`/community/posts/${encodeURIComponent(postId)}`),
  react: postId => apiRequest(`/community/posts/${encodeURIComponent(postId)}/reactions`, { method: 'POST', body: {} }),
  addComment: (postId, body) => apiRequest(`/community/posts/${encodeURIComponent(postId)}/comments`, { method: 'POST', body: { body } }),
  comments: (postId, cursor) => apiRequest(`/community/posts/${encodeURIComponent(postId)}/comments${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ''}`),
  createReport: payload => apiRequest('/community/reports', { method: 'POST', body: payload }),
  profile: userId => apiRequest(`/community/profile/${encodeURIComponent(userId)}`),
  setAvatar: mediaId => apiRequest('/community/profile/avatar', { method: 'PUT', body: { mediaId } }),
  setAbout: aboutMe => apiRequest('/community/profile/about', { method: 'PUT', body: { aboutMe } }),
  async changeAvatar(file) {
    const image = await communityMedia.resize(file);
    const uploaded = await communityMedia.upload(image);
    const result = await communityApi.setAvatar(uploaded.mediaId);
    return result.avatarPath;
  },
  follow: userId => apiRequest(`/community/follow/${encodeURIComponent(userId)}`, { method: 'POST', body: {} }),
  unfollow: userId => apiRequest(`/community/follow/${encodeURIComponent(userId)}`, { method: 'DELETE' }),
  notifications: cursor => apiRequest(`/community/notifications?limit=50${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`),
  markNotificationsRead: payload => apiRequest('/community/notifications/read', { method: 'POST', body: payload }),
  listReports: (status = 'open') => apiRequest(`/community/reports?status=${encodeURIComponent(status)}`),
  resolveReport: reportId => apiRequest(`/community/reports/${encodeURIComponent(reportId)}/resolve`, { method: 'POST', body: {} }),
  hidePost: (postId, payload) => apiRequest(`/community/posts/${encodeURIComponent(postId)}/hide`, { method: 'POST', body: payload }),
  unhidePost: postId => apiRequest(`/community/posts/${encodeURIComponent(postId)}/unhide`, { method: 'POST', body: {} }),
  hideComment: (commentId, payload) => apiRequest(`/community/comments/${encodeURIComponent(commentId)}/hide`, { method: 'POST', body: payload }),
  unhideComment: commentId => apiRequest(`/community/comments/${encodeURIComponent(commentId)}/unhide`, { method: 'POST', body: {} }),
};
